// src/components/ChatWidget.jsx
import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { isWebAdmin } from "@/auth/webAccess";
import { isPlatformSuperadmin } from "@/auth/saasSession";

export const readinessReplacesChat = (pathname = '', search = '') => (
  /^\/incident-details\/[^/]+\/?$/.test(pathname)
  && new URLSearchParams(search).get('scenario') !== '1'
);

export const canUseGlobalChat = (user) => (
  isWebAdmin(user) && !isPlatformSuperadmin(user)
);

export const reportsWorkspaceReplacesGlobalChat = (reportsCopilotActive = false) => (
  reportsCopilotActive === true
);

const ChatWidget = ({ suppressed = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  let currentUser = null;
  try {
    currentUser = JSON.parse(localStorage.getItem('user') || 'null');
  } catch (_) {
    currentUser = null;
  }

  // Leaders use only incident-scoped chat/call surfaces. The global assistant
  // remains available to institution admins, never platform control accounts.
  if (!canUseGlobalChat(currentUser)) return null;
  if (readinessReplacesChat(location.pathname, location.search)) return null;
  if (reportsWorkspaceReplacesGlobalChat(suppressed)) return null;

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
          if (!isOpen) setIsLoading(true); 
        }}
        className="fixed bottom-5 right-5 bg-blue-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-blue-700 transition z-40"
      >
        {isOpen ? <X size={28} /> : <MessageCircle size={28} />}
      </button>

      {isOpen && (
        <div
          style={{
           boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
          }}
          className=" fixed bottom-24 right-5 w-[400px] h-[500px] rounded-xl overflow-hidden z-50 bg-white "
        >
          {isLoading && (
            <div className="flex h-full items-center justify-center w-full">
              Loading chat...
            </div>
          )}

          <iframe
            src="https://chatbot.disasterms.net/"
            // src="http://54.88.79.25:3000/"
            title="Chat Widget"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            allow="microphone"
            onLoad={() => setIsLoading(false)}
          />
        </div>
      )}
    </>
  );
};

export default ChatWidget;
